import React, { useEffect, useState, memo } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import {
  Header,
  Tabla,
  ModalFormulario,
  ModalGeneral,
  ModalFormularioV2,
} from "components";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import { AddBox, Refresh } from "@material-ui/icons";
import FormNuevaSolicitud from "./FormNuevaSolicitud";
import FormularioRequerimientosV2 from "./FormularioRequerimientosV2";
import Observaciones from "../Panel/Components/Observaciones/Observaciones";
import Incidencias from "./Incidencia";
import Tarea from "./Tarea";
import Calificacion from "./Calificacion";
import Page from "components/Page";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import getErrorMessage from "utils/getErrorMessage";
import Propuesta from "./Propuesta";
import FechaP from "./FechaP";
import Cancelar from "./Cancelar";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  add: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: theme.palette.add.main,
    "&:hover": {
      backgroundColor: "#4D8487",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },

    height: "50%",
  },
  refresh: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: "#3cd938b0",
    "&:hover": {
      backgroundColor: "#319E2E",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },

    height: "50%",
  },
}));

const Solicitud = ({ permisos, usuario }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [catalogos, setCatalogos] = useState({ proyectos: [], areas: [] });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const [modalCancelar, setModalCancelar] = useState({
    open: false,
    titulo: "",
  });
  const [nuevaSolicitud, setNuevaSolicitud] = useState({
    open: false,
    formulario: null,
    props: null,
  });
  const [requerimientos, setRequerimientos] = useState({
    open: false,
    formulario: null,
    props: null,
  });
  const [ctl, setCtl] = useState({
    proyectos: [],
    tipoincidencias: [],
    responsables: [],
  });
  const {
    register,
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
  } = useForm();
  const [options, setOptions] = useState([{ id: -1, nestatus: "TODAS" }]);
  const [btndisabled, setBtndisabled] = useState(false);

  const servicios = {
    cambioEstatus: (data) =>
      serviciosSolicitudes.cambioEstatus(
        respuesta(cerrarAdvertencia),
        setCargando,
        {
          idsolicitud: data.idsolicitud,
          idpropuesta: data.idpropuesta,
          estatus: data.nestatus,
          tipo: data.tipo,
          estatusSelect: getValues("estatus")?.id || -1,
        }
      ),
  };
  const [datosF, setDato] = React.useState({
    estatus: "0",
    solicitud: "0",
  });
  /**
   * LO QUE NECESITA COMENTARIOS
   */
  const [comAdvertencia, setComAdvertencia] = useState({
    open: false,
    titulo: "",
  });
  const cerrarComAdvertencia = () =>
    setComAdvertencia({ ...comAdvertencia, open: false });

  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: "" });
  const cerrarModalCancelar = () =>
    setModalCancelar({ ...modalCancelar, open: false });
  const respuesta = (onSuccess) => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data);
      cerrarAdvertencia();
    }
    setMensaje({ open: true, status: status, value: mensaje });
  };

  const respuestaTarea = (onSuccess) => (data) => {
    if (data.status > 0) {
      onSuccess();
      cerrarAdvertencia();
    }
    setMensaje({ open: true, status: data.status, value: data.mensaje });
  };

  const clickCancelar = (accion) => (item) => {
    let title = "";
    let cambio = null;

    if (accion == "cnclr") {
      title = "CANCELACIÓN DE SOLICITUD #" + item.idsolicitud;
      cambio = 0;
    } else if (accion == "rndr") {
      title = "REANUDAR SOLICITUD";
      cambio = 4;
    } else if (accion == "psr") {
      title = "PAUSAR SOLICITUD";
      cambio = 3;
    }

    setModalCancelar({
      open: true,
      width: "sm",
      paddingDisabled: true,
      titulo: title,
      Formulario: Cancelar,
      item: { ...item, observacion: "", cambio: cambio, accion: accion },
    });
  };
  const clickPropuesta = (item) => {
    let propModal = {
      titulo: "GENERAR PROPUESTA DE GERENTE",
      tipo: 0,
      // mensaje:"¿Está seguro de enviar su Vo.Bo para la orden de compra " + item['folio'] + "?"
    };
    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "lg",
      paddingDisabled: true,
      Formulario: Propuesta,
      guardar: guardarPropuesta,
      ...propModal,
    });
  };

  const clickEditar = (item) => {
    let title =
      item.estatusPropuesta == 6
        ? "ACTUALIZAR PROPUESTA DE GERENTE #" + item["idsolicitud"]
        : "PROPUESTA DE DIRECTOR TI #" + item["idsolicitud"];
    serviciosSolicitudes.datosUpdate(
      (respuesta) =>
        setMAdvertencia({
          open: true,
          titulo: title,
          width: "lg",
          Formulario: Propuesta,
          item: {
            ...item,
            proyecto: respuesta.proyecto,
            equipo: respuesta.equipo,
            propuesta: {
              ...respuesta.propuesta,
              tipoincidencia: respuesta.tipoincidencia,
            },
            personas: respuesta.personas,
          },
          // edicionEspecial: especial && item.idvbueno,
          guardar: actualizarPropuesta(
            item["idsolicitud"],
            respuesta.propuesta.idpropuesta,
            item.estatusPropuesta
          ),
          props: { accion: 1 },
        }),
      // register('persona', {required:{ value: true, message: 'Campo requerido'} });
      setCargando,
      { idsolicitud: item.idsolicitud, idpropuesta: item.idpropuesta }
    );
  };

  const descargarDocsReq = (row) => {
    setCargando(true);
    serviciosSolicitudes.getDocumentosReq(
      (data) => {
        if (data.infoarchivosReq.length > 0) {
          data.infoarchivosReq.forEach((element, i) => {
            (function(index) {
              setTimeout(function() {
                const link = document.createElement("a");
                link.href =
                  "https://dashboard.gphsis.com/back/Login/obtenerArchivoReq/" +
                  element.idarchivoreq +
                  "/solicitud";
                link.download = "filename";
                link.click();
              }, (i + 1) * 2000);
            })(i);
          });
          setTimeout(function() {
            setCargando(false);
          }, 4000);
        } else {
          setCargando(false);
          console.log("NO SE ENCONTRÓ ARCHIVO DE REQUERIMIENTOS");
          setMensaje({
            open: true,
            status: 0,
            value: "No se encontró archivo de requerimientos",
          });
        }
      },
      () => {},
      { idsolicitud: row.idsolicitud }
    );
  };

  const guardarPropuesta = (data) => {
    serviciosSolicitudes.propuestaCreate(
      respuesta(cerrarAdvertencia),
      setCargando,
      { ...data, estatusSelect: getValues("estatus")?.id || -1 }
    );
  };

  const cerrarRequerimientos = () =>
    setRequerimientos({ ...requerimientos, open: false });
  const guardarRequerimiento = (idsolicitud) => (data) => {
    let dataFormPivote = { ...data };
    dataFormPivote.idsolicitud = idsolicitud;
    dataFormPivote.idresponsable = data.responsable.idpersona;
    dataFormPivote.tipo_solicitud = data.tipo_solicitud.idopc;
    const dataFormEstructura = new FormData();
    Object.keys(dataFormPivote).forEach((key) => {
      if (key != "filefield")
        dataFormEstructura.append(key, dataFormPivote[key]);
    });

    if (data.aplicarReq)
      dataFormPivote.filefield.forEach((file) =>
        dataFormEstructura.append("filefield[]", file.file)
      );

    dataFormEstructura.append("estatusSelect", getValues("estatus")?.id || -1);
    // // serviciosSolicitudes.requerimientosCreate((data) => { }, setCargando, dataFormEstructura);
    serviciosSolicitudes.requerimientosCreate(
      respuesta(cerrarRequerimientos),
      setCargando,
      dataFormEstructura
    );
  };

  const guardarFecha = (data, idsolicitud) => {
    let a = {
      fecha_presentacion: data.fecha_presentacion,
      idsolicitud: idsolicitud,
    };

    serviciosSolicitudes.saveFechaPresentacion(
      respuesta(cerrarAdvertencia),
      setCargando,
      { ...a, estatusSelect: getValues("estatus")?.id || -1 }
    );
  };

  const guardarInci = (data, idsolicitud, ma, idmalcance) => {
    let a = {
      titulo: data.titulo,
      descripcion: data.descripcion,
      involucrados: data.involucrados,
      idsolicitud: idsolicitud,
      ma: ma,
      modifa: idmalcance,
    };

    serviciosSolicitudes.saveIncidenciaReq(
      respuesta(cerrarAdvertencia),
      setCargando,
      { ...a, estatusSelect: getValues("estatus")?.id || -1 }
    );
  };

  const guardarTarea = (data) => {
    serviciosSolicitudes.tareasCreateSol(
      respuestaTarea(cerrarAdvertencia),
      setCargando,
      { ...data, estatusSelect: getValues("estatus")?.id || -1 }
    );
  };
  const guardarCalificacion = (inf) => {
    serviciosSolicitudes.guardacalificacion(
      (resp) => {
        if (resp.status > 0) {
          data.map((sol) => {
            if (sol.idsolicitud == inf.idsolicitud)
              sol.calificacionEnc = inf.calificacion;
          });
          cerrarAdvertencia();
          setMensaje({ open: true, status: resp.status, value: resp.mensaje });
        } else {
          setMensaje({ open: true, status: resp.status, value: resp.mensaje });
        }
      },
      setCargando,
      inf
    );
  };

  const guardarSeguimiento = (data) => {
    // let a = {fecha_presentacion:data.fecha_presentacion, idsolicitud: idsolicitud};
    serviciosSolicitudes.finalizarSol(
      respuesta(cerrarAdvertencia),
      setCargando,
      { ...data, estatusSelect: getValues("estatus")?.id || -1 }
    );
  };

  const actualizarPropuesta = (idsolicitud, idpropuesta, estatusPropuesta) => (
    data,
    cambio,
    tipo
  ) => {
    // VARIABLES PARA EQUIPO
    let arrGeneral = data.equipoOriginal.map((p) => p.idpersona);
    let arrNuevo = data.equipo.map((p) => p.idpersona);
    let nuevo = data.equipo.map((per) =>
      arrGeneral.includes(per.idpersona) ? per : { ...per, accion: "ins" }
    );
    let eliminar = data.equipoOriginal
      .filter((per) => !arrNuevo.includes(per.idpersona))
      .map((per) => ({ ...per, accion: "dlt" }));
    // VARIABLES PARA PROYECTO
    let arrGeneralPro = data.proyectoOriginal.map((p) => p.idproyecto);
    let arrNuevoPro = data.general.proyecto.map((p) => p.idproyecto);
    let nuevoPro = data.general.proyecto.map((pro) =>
      arrGeneralPro.includes(pro.idproyecto) ? pro : { ...pro, accion: "ins" }
    );
    let eliminarPro = data.proyectoOriginal
      .filter((pro) => !arrNuevoPro.includes(pro.idproyecto))
      .map((pro) => ({ ...pro, accion: "dlt" }));

    if (estatusPropuesta == 6)
      serviciosSolicitudes.propuestaUpdate(
        respuesta(cerrarAdvertencia),
        setCargando,
        {
          general: data.general,
          equipo: nuevo.concat(eliminar),
          propuesta: data.propuesta,
          proyecto: nuevoPro.concat(eliminarPro),
          idsolicitud: idsolicitud,
          idpropuesta: idpropuesta,
          estatusSelect: getValues("estatus")?.id || -1,
        }
      );
    else {
      serviciosSolicitudes.propuestaUpdateD(
        respuesta(cerrarAdvertencia),
        setCargando,
        {
          general: data.general,
          equipo: nuevo.concat(eliminar),
          propuesta: data.propuesta,
          proyecto: nuevoPro.concat(eliminarPro),
          idsolicitud: idsolicitud,
          idpropuesta: idpropuesta,
          cambio: cambio,
          tipo: tipo,
          estatusSelect: getValues("estatus")?.id || -1,
        }
      );
    }
  };

  const cambioEstatus = (accion) => (item) => {
    let title = "";
    let mnsj =
      "¿Está seguro de cambiar el estatus a la propuesta de la solicitud #" +
      item.idsolicitud +
      "?";
    let propModal = "";
    let cambio = null;

    if (accion == "envdir") {
      title = "ENVIAR A DIRECCIÓN DE TI";
      mnsj =
        "¿Está seguro de enviar su propuesta de la solicitud #" +
        item.idsolicitud +
        " a dirección de TI?";
      cambio = 7;
    } else if (accion == "ptester") {
      title = "ENVIAR A PRUEBAS DE TESTER";
      mnsj =
        "Si tiene modificaciones de alcance en desarrollo estas también serán enviadas a pruebas de tester. ¿Está seguro de enviar a pruebas de tester la solicitud #" +
        item.idsolicitud +
        " ?";
      cambio = 15;
    } else if (accion == "fin") {
      title = "FINALIZAR";
      cambio = 5;
    } else if (accion == "regresar") {
      title = "REGRESAR A DESARROLLO";
      mnsj =
        "¿Está seguro de regresar a desarrollo la solicitud #" +
        item.idsolicitud +
        " ?";
      cambio = 4;
    } else if (accion == "regresarReq") {
      title = "REGRESAR REQUERIMIENTOS A TESTER";
      mnsj =
        "¿Está seguro de regresar a tester la solicitud #" +
        item.idsolicitud +
        " ?";
      cambio = 14;
    }

    propModal = {
      titulo: title,
      mensaje: mnsj,
    };

    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "sm",
      paddingDisabled: false,
      aceptar: () =>
        servicios.cambioEstatus({
          idsolicitud: item.idsolicitud,
          idpropuesta: item.idpropuesta,
          nestatus: cambio,
          tipo: accion,
        }),
      ...propModal,
    });
  };

  const cmbEstatusComentario = (data) => {
    let idsolicitud = modalCancelar.item.idsolicitud;
    serviciosSolicitudes.cmbEstatusComentario(
      respuesta(cerrarModalCancelar),
      setCargando,
      {
        ...data,
        idsolicitud,
        nestatus: modalCancelar.item.cambio,
        tipo: modalCancelar.item.accion,
        estatusSelect: getValues("estatus")?.id || -1,
      }
    );
  };

  const clickRequerimientos = (item) => {
    let propModal = {
      titulo: "GENERAR REQUERIMIENTOS",
      tipo: 0,
    };
    setRequerimientos({
      open: true,
      item: item,
      edicionEspecial: false,
      width: "lg",
      paddingDisabled: true,
      formulario: FormularioRequerimientosV2,
      aceptar: () => {},
      ...propModal,
    });
  };

  const clickFecha = (item) => {
    let propModal = {
      titulo: "PRESENTACIÓN DE ENTREGA",
      tipo: 0,
    };
    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "sm",
      paddingDisabled: true,
      Formulario: FechaP,
      guardar: guardarFecha,
      ...propModal,
    });
  };

  const clickFin = (item) => {
    let propModal = {
      titulo: "FINALIZAR",
      tipo: 0,
    };

    serviciosSolicitudes.getEquipo(
      (respuesta) =>
        setMAdvertencia({
          open: true,
          item: { ...item, equipo: respuesta },
          edicionEspecial: false,
          width: "md",
          paddingDisabled: true,
          Formulario: FechaP,
          guardar: guardarSeguimiento,
          ...propModal,
        }),
      setCargando,
      { idsolicitud: item.idsolicitud }
    );
  };

  const navigate = useNavigate();
  const clickPanelSol = (item) => {
    navigate("Panel", { state: { id: item.idsolicitud,idpropuesta: item.idpropuesta } });
  };

  const clickObservacion = (item) => {
    serviciosSolicitudes.getObservaciones(
      (respuesta) =>
        setComAdvertencia({
          open: true,
          titulo: "HISTORIAL",
          width: "sm",
          Formulario: Observaciones,
          item: respuesta.observaciones,
          id: item.idsolicitud,
        }),
      // setMAdvertencia({
      //   open: true,
      //   titulo: "OBSERVACIONES",
      //   width: "sm",
      //   Formulario: Observaciones,
      //   item: respuesta.observaciones,
      // }),
      // register('persona', {required:{ value: true, message: 'Campo requerido'} });
      setCargando,
      { idsolicitud: item.idsolicitud, idpropuesta: item.idpropuesta }
    );
  };

  const clickIncidencia = (item) => {
    let propModal = {
      titulo: "INCIDENCIA DURANTE CREACIÓN DE REQUERIMIENTOS",
      tipo: 0,
    };

    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      paddingDisabled: true,
      Formulario: Incidencias,
      guardar: guardarInci,
      ...propModal,
    });
  };

  const clickNuevaTarea = (item) => {
    let propModal = {
      titulo: "CREACIÓN DE TAREA",
      tipo: 0,
    };

    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      paddingDisabled: true,
      Formulario: Tarea,
      guardar: guardarTarea,
      ...propModal,
    });
  };
  const clickCalificacionEnc = (item) => {
    let propModal = {
      titulo:
        item.calificacionEnc > 0
          ? "EDITAR CALIFICACIÓN"
          : "CALIFICACIÓN ENCUESTA",
      tipo: 0,
    };

    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      paddingDisabled: true,
      Formulario: Calificacion,
      guardar: guardarCalificacion,
      ...propModal,
    });
  };
  const clickMalcance = (item) => {
    navigate("/ModAlcance", { state: { id: item.idsolicitud } });
  };

  const obtenerSolicitudes = (event, value) => {
    serviciosSolicitudes.getSolicitudesByestatus(
      (data) => {
        setData(data.solicitudes);
        setOptions([{ id: -1, nestatus: "TODAS" }, ...data.estatusSol]);
        setCatalogos({
          ...catalogos,
          proyectos: data.proyectos,
          areas: data.areas,
          modulos: data.modulos,
        });
      },
      setCargando,
      {
        estatus: getValues("estatus")?.id || -1,
      }
    );
  };

  useEffect(() => {
    register("estatus");
    obtenerSolicitudes();
    serviciosSolicitudes.ctlSolicitud(
      (data) => {
        setCtl({
          ...ctl,
          proyectos: data.proyectos,
          tipoincidencias: data.tipoincidencias,
          responsables: data.responsables ? data.responsables : [],
          prioridad: data.prioridad ? data.prioridad : [],
        });
      },
      setCargando,
      {}
    );
  }, []);

  const clickGrafica = (item) => {
    navigate("/Panelsol", { state: { idsolicitud: item.idsolicitud } });
  };
  const acciones = [
    {
      label: "Nueva solicitud",
      icon: <AddBox fontSize="small" />,
      click: () => abrirFormularioNuevaSolicitud,
      disabled: !permisos.crear,
      color: classes.add,
    },
    {
      label: "Recargar",
      icon: <Refresh fontSize="small" />,
      click: () => obtenerSolicitudes,
      disabled: false,
      color: classes.refresh,
    },
  ];
  const accionesFila = [
    // { label:'Lista de insumos', onClick:clickInsumosCancelados,enabled:(item)=> ["50","0"].includes(item.idestatus) },
    // { label: 'Replicar', onClick: abrirReplicar, enabled: Boolean(permisos.cnc) },
    {
      label: "CANCELAR",
      onClick: clickCancelar("cnclr"),
      enabled: (item) => ![0, 5].includes(item.idestatus) && permisos.cancelar,
    },
    {
      label: "GENERAR PROPUESTA",
      onClick: clickPropuesta,
      enabled: (item) => [1].includes(item.idestatus) && permisos.cr_prop,
    },
    {
      label: "EDITAR PROPUESTA",
      onClick: clickEditar,
      enabled: (item) =>
        [6].includes(item.estatusPropuesta) && permisos.cr_prop,
    },
    {
      label: "ENVIAR A DIRECCIÓN DE TI",
      onClick: cambioEstatus("envdir"),
      enabled: (item) =>
        [6].includes(item.estatusPropuesta) && permisos.cr_prop,
    },
    {
      label: "VER PROPUESTA",
      onClick: clickEditar,
      enabled: (item) => [7].includes(item.estatusPropuesta),
    },
    {
      label: "PAUSAR ",
      onClick: clickCancelar("psr"),
      enabled: (item) =>
        [8].includes(item.estatusPropuesta) &&
        [4].includes(item.idestatus) &&
        permisos.pausar,
    },
    {
      label: "REANUDAR",
      onClick: clickCancelar("rndr"),
      enabled: (item) => [3].includes(item.idestatus),
    },
    {
      label: "ENVIAR A PRUEBAS DE TESTER",
      onClick: cambioEstatus("ptester"),
      enabled: (item) =>
        [4].includes(item.idestatus) &&
        item.totalTareas > 0 &&
        item.tareasActivas == 0 &&
        usuario[0].idrol == 2 &&
        item.ma_activas == 0,
    },
    {
      label: "PRESENTACIÓN DE ENTREGA",
      onClick: clickFecha,
      enabled: (item) =>
        [15].includes(item.idestatus) &&
        item.totalTareas > 0 &&
        item.tareasActivas == 0 &&
        permisos.presentacion &&
        item.presentacion == 1,
    },
    {
      label: "FINALIZAR",
      onClick: cambioEstatus("fin"),
      enabled: (item) =>
        [15].includes(item.idestatus) &&
        item.totalTareas > 0 &&
        item.tareasActivas == 0 &&
        permisos.finalizar &&
        item.presentacion == 0,
    },
    {
      label: "FINALIZAR",
      onClick: clickFin,
      enabled: (item) =>
        [16].includes(item.idestatus) &&
        item.totalTareas > 0 &&
        item.tareasActivas == 0 &&
        permisos.finalizar &&
        item.presentacion == 1,
    },
    {
      label: "GESTIONAR SOLICITUD",
      onClick: clickPanelSol,
      enabled: (item) =>
        [8].includes(item.estatusPropuesta) &&
        [4, 15, 16].includes(item.idestatus),
    },
    {
      label: "MODIFICACIÓN DE ALCANCE",
      onClick: clickMalcance,
      notificacion: true,
      enabled: (item) => [4, 5].includes(item.idestatus),
    },
    {
      label: "INDICADORES",
      onClick: clickGrafica,
      enabled: (item) =>
        [8].includes(item.estatusPropuesta) &&
        [4, 5].includes(item.idestatus) &&
        permisos.indicadores,
    },
    {
      label: "GENERAR REQUERIMIENTOS",
      onClick: clickRequerimientos,
      enabled: (item) =>
        [14].includes(item.idestatus) && permisos.requerimientos,
    },
    { label: "HISTORIAL", onClick: clickObservacion, enabled: true },
    {
      label: "INCIDENCIA",
      onClick: clickIncidencia,
      enabled: (item) =>
        [14].includes(item.idestatus) && permisos.requerimientos,
    },
    {
      label: "REGRESAR A DESARROLLO",
      onClick: cambioEstatus("regresar"),
      enabled: (item) =>
        [15].includes(item.idestatus) && item.tareasActivas > 0,
    },
    {
      label: "REGRESAR A TESTER",
      onClick: cambioEstatus("regresarReq"),
      enabled: (item) => [1].includes(item.idestatus) && usuario[0].idrol == 2,
    },
    {
      label: "AGREGAR TAREAS",
      onClick: clickNuevaTarea,
      enabled: (item) =>
        [1, 2].includes(item.idestatus) && permisos.crear_tarea,
    },
    {
      label: "CALIFICACION DE ENCUESTA",
      onClick: clickCalificacionEnc,
      enabled: (item) =>
        [5].includes(item.idestatus) &&
        permisos.calificacionEnc &&
        [1, 2].includes(item.nvlbono),
    },
    {
      label: "DOCUMENTO DE REQUERIMIENTOS",
      onClick: descargarDocsReq,
      enabled: (item) => item.docs > 0,
    },
    // { label: "REGRESAR A TESTER", onClick: cambioEstatus("regresarReq"), enabled: (item) => [1].includes(item.idestatus) && usuario[0].idrol == 2},
  ];

  const handleChangeEstatus = (event, value) => {
    if (value) {
      setValue("estatus", value);

      // setDato({ ...datosF, estatus:  });
      if (value.id != null) {
        serviciosSolicitudes.getSolicitudesByestatus(
          (data) => {
            setData(data.solicitudes);
          },
          setCargando,
          {
            ...datosF,
            estatus: value.id,
          }
        );
      }
    } else {
      setValue("estatus", { id: -1, nestatus: "TODAS" });
    }
  };
  // nueva Solicituda
  const cerrarNuevaSolicitud = () => {
    setNuevaSolicitud({ ...nuevaSolicitud, open: false });
    setBtndisabled(false);
  };
  const abrirFormularioNuevaSolicitud = () => {
    setNuevaSolicitud({
      open: true,
      formulario: FormNuevaSolicitud,
      aceptar: () => {},
    });
  };
  const guardarNuevaSolicitud = (dataForm) => {
    let proyectoData = dataForm.proyecto;
    setBtndisabled(true);
    let narray = {
      ...dataForm,
      correo: dataForm.correo.map((email) => email.info),
    };
    let dataFormPivote = { ...narray };
    dataFormPivote.proyecto = dataFormPivote.proyecto.nproyecto;
    dataFormPivote.idproyecto = proyectoData.idproyecto;
    dataFormPivote.solicitante = dataFormPivote.solicitante;
    dataFormPivote.tipo_solicitud = dataFormPivote.tipo_solicitud.idopc; //`${usuario[0]?.nombre} ${usuario[0]?.apaterno} ${usuario[0]?.amaterno}`;
    dataFormPivote.tipo_app = dataFormPivote.tipo_app.opcion;
    dataFormPivote.idprioridad = dataFormPivote.idprioridad.idopc;
    dataFormPivote.area = dataFormPivote.area.area;
    dataFormPivote.idmodulo = dataFormPivote.modulo.idmodulo;

    const dataFormEstructura = new FormData();
    Object.keys(dataFormPivote).forEach((key) => {
      if (key != "filefield")
        dataFormEstructura.append(key, dataFormPivote[key]);
    });
    dataFormPivote.filefield.forEach((file) =>
      dataFormEstructura.append("filefield[]", file.file)
    );
    dataFormEstructura.append("estatusSelect", getValues("estatus")?.id || -1);
    serviciosSolicitudes.insertSolicitud(
      (status, mensaje, data) => {
        if (status > 0) {
          setData(data);
          cerrarNuevaSolicitud();
        }
        setMensaje({ open: true, status: status, value: mensaje });
      },
      setCargando,
      dataFormEstructura
    );
  };
  // fin nueva solicitud
  const columns = [
    { label: "#", name: "idsolicitud", filtrar: true },
    { label: "PRIORIDAD", name: "nprioridad", filtrar: true, tamano: 6 },
    { label: "TÍTULO", name: "titulo", filtrar: true, tamano: 20 },
    { label: "DESCRIPCION", name: "desc_solicitud", hidden: true },
    { label: "SISTEMA", name: "sistema", filtrar: true },
    {
      label: "TIPO SOLICITUD",
      name: "ntipo_solicitud",
      filtrar: true,
      tamano: 8,
    },
    { label: "SOLICITANTE", name: "solicitante", filtrar: true },
    { label: "ESTATUS", name: "nestatus", filtrar: true },
    { label: "F. SOLICITUD", name: "fecha_creacion", filtrar: true, tamano: 6 },
    {
      label: "PROPUESTA INICIO",
      name: "propfecha_inicio",
      filtrar: true,
      tamano: 9,
    },
    { label: "PROPUESTA FIN", name: "propfecha_fin", filtrar: true, tamano: 9 },
    {
      label: "TOTAL DE HORAS PROPUESTA",
      name: "hrsPropuesta",
      filtrar: true,
      hidden: true,
    },
    // {
    //   label: "# MODIFICACIÓN DE ALCANCE",
    //   name: "totalMA",
    //   filtrar: true,
    //   hidden: true,
    // },
    // {
    //   label: "HORAS MODIFICACIÓN DE ALCANCE",
    //   name: "hrsPropuesta_ma",
    //   filtrar: true,
    //   hidden: true,
    // },
    // {
    //   label: "# TAREAS AGREGADAS",
    //   name: "totalTareas",
    //   filtrar: true,
    //   hidden: true,
    // }, // hidden:true
    {
      label: "HORAS POR ASIGNAR",
      name: "hxasignar",
      hidden: true,
    },
    {
      label: "TOTAL HORAS COMPLETADAS",
      name: "hrsCerradas",
      hidden: true,
    },
  ];
  return (
    <Page
      className={classes.root}
      title="Panel de solicitudes"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header
          title="Panel"
          subtitle={
            <Grid container spacing={2} alignItems="center">
              <Grid item>SOLICITUDES</Grid>
              {/* <Grid item><Button variant="contained" size="small" color="primary" onClick= {abrirFormularioNuevaSolicitud}><AddBox/></Button></Grid> */}
            </Grid>
          }
        />

        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Tabla
              keyTabla="solInicio"
              rows={data}
              columns={columns}
              accionesTabla={acciones}
              optionsSelect={options} /// usuario[0].idrol == 5?optionsT:options
              defaultV={options[0]}
              register={register}
              change={handleChangeEstatus}
              errors={getErrorMessage(errors)}
              watch={watch}
              accionesFila={accionesFila}
              isSeleccionable={false}
              filterGeneralDisabled={false}
              columnKey={"idsolicitud"}
              verBono={permisos?.verBono}
              // filtrosTabla = {localStorage.getItem('filtros') != null? JSON.parse(localStorage.getItem('filtros')):filtrosTabla}
              // setFiltrosTabla = {setFiltrosTabla}
              DetailByrow={(row) =>
                [0, 1, 2, 14].includes(row.idestatus) ? (
                  <Box margin={3}>
                    <Typography>
                      <b>ESTATUS:</b>&nbsp;{row.nestatus}
                    </Typography>
                    <Typography>
                      <b># PROPUESTAS REALIZADAS:</b>&nbsp;{row.npropuestas}
                    </Typography>
                  </Box>
                ) : row.porcentaje == 0 ? (
                  <Box margin={1}>
                    <Typography>
                      <b># PROPUESTAS REALIZADAS:</b>&nbsp;{row.npropuestas}
                    </Typography>
                    <Typography align="center">
                      Sin tareas completadas
                    </Typography>
                  </Box>
                ) : (
                  <Box margin={3}>
                    <Typography>
                      <b># PROPUESTAS REALIZADAS:</b>&nbsp;{row.npropuestas}
                    </Typography>
                    <Typography>
                      <b>TOTAL HORAS PROPUESTAS:</b>&nbsp;
                      {row.total_prop_nhoras}
                    </Typography>
                    <Typography>
                      <b># TAREAS AGREGADAS:</b>&nbsp;{row.totalTareas}
                    </Typography>
                    <Typography>
                      <b>HORAS COMPLETADAS:</b>&nbsp;{row.hrsCerradas}
                    </Typography>
                    <ProgressBar
                      animated
                      variant={row.colorPorcentaje}
                      now={row.porcentaje}
                      label={`${row.porcentaje}%`}
                    />{" "}
                    {/** `${now}%` */}
                  </Box>
                )
              }
            />
          </Grid>
        </Grid>

        <ModalGeneral
          open={mAdvertencia.open}
          titulo={mAdvertencia.titulo}
          width={mAdvertencia.width}
          paddingDisabled={mAdvertencia.paddingDisabled}
          ContenidoMensaje={mAdvertencia.mensaje}
          OnCerrar={cerrarAdvertencia}
          acciones={
            <React.Fragment>
              {Boolean(mAdvertencia.aceptar) && (
                <Button color="primary" onClick={mAdvertencia.aceptar}>
                  ACEPTAR
                </Button>
              )}
            </React.Fragment>
          }
        >
          {mAdvertencia.Formulario && (
            <mAdvertencia.Formulario
              setMensaje={setMensaje}
              setCargando={setCargando}
              tipo={mAdvertencia.tipo}
              edicionEspecial={mAdvertencia.edicionEspecial}
              permisos={permisos}
              datoS={mAdvertencia.item}
              usuario={usuario}
              guardar={mAdvertencia.guardar}
              servicios={servicios}
              ctlg={ctl}
              respuesta={respuesta}
              cerrarAdvertencia={cerrarAdvertencia}
              {...mAdvertencia.props}
            />
          )}
        </ModalGeneral>
        <ModalFormularioV2
          open={nuevaSolicitud.open}
          width="sm"
          titulo="Nueva solicitud"
          OnCancelar={cerrarNuevaSolicitud}
          aceptar={guardarNuevaSolicitud}
          bloqueo={btndisabled}
        >
          {nuevaSolicitud.formulario && (
            <nuevaSolicitud.formulario
              usuario={usuario[0]}
              catalogos={catalogos}
              {...nuevaSolicitud.props}
            />
          )}
        </ModalFormularioV2>
        <ModalFormulario
          open={modalCancelar.open}
          width={modalCancelar.width}
          titulo={modalCancelar.titulo}
          aceptar={handleSubmit(cmbEstatusComentario)}
          OnCancelar={cerrarModalCancelar}
        >
          {modalCancelar.Formulario && (
            <modalCancelar.Formulario
              register={register}
              errors={getErrorMessage(errors)}
              watch={watch}
              // ctlg={ctls}
              defaultItem={modalCancelar.item || {}}
              setValue={setValue}
            />
          )}
          {modalCancelar.msg ? (
            <Typography variant="subtitle1" gutterBottom>
              {modalCancelar.msg}
            </Typography>
          ) : null}
        </ModalFormulario>
        <ModalFormularioV2
          open={requerimientos.open}
          width={requerimientos.width}
          titulo={requerimientos.titulo}
          OnCancelar={cerrarRequerimientos}
          aceptar={guardarRequerimiento(requerimientos.item?.idsolicitud)}
        >
          {requerimientos.formulario && (
            <requerimientos.formulario
              setMensaje={setMensaje}
              setCargando={setCargando}
              permisos={permisos}
              datoS={requerimientos.item}
              usuario={usuario}
              ctlg={ctl}
              catalogos={catalogos}
              {...requerimientos.props}
            />
          )}
        </ModalFormularioV2>

        <ModalGeneral
          open={comAdvertencia.open}
          titulo={comAdvertencia.titulo}
          paddingDisabled={comAdvertencia.paddingDisabled}
          ContenidoMensaje={comAdvertencia.mensaje}
          OnCerrar={cerrarComAdvertencia}
        >
          {comAdvertencia.Formulario && (
            <comAdvertencia.Formulario
              setMensaje={setMensaje}
              setCargando={setCargando}
              tipo={comAdvertencia.tipo}
              edicionEspecial={comAdvertencia.edicionEspecial}
              permisos={permisos}
              datoS={comAdvertencia.item}
              usuario={usuario}
              id={comAdvertencia.id}
              ctlg={ctl}
              guardar={comAdvertencia.guardar}
              servicios={servicios}
              {...comAdvertencia.props}
            />
          )}
        </ModalGeneral>
      </Container>
    </Page>
  );
};

export default memo(Solicitud);
